import { FC } from "react"
import classes from "./styles.module.scss"
import { SectionContainer } from "@/shared/ui/SectionContainer"
import { Logo } from "@/shared/ui/Logo"
import { useAppSelector } from "@/shared/lib/store"
import { Link } from "react-router-dom"
import { selectCompanyLogo } from "@/entities/options"
import { HeaderInfo } from "../HeaderInfo"

interface HeaderProps {
	isOpen: boolean
	openSidebar: () => void
}

export const Header: FC<HeaderProps> = ({ openSidebar, isOpen }) => {
	const logo = useAppSelector(selectCompanyLogo)

	return (
		<div className={classes.header}>
			<SectionContainer extraClasses={[classes.inner]}>
				{logo && (
					<Link to="/">
						<Logo src={logo} alt="logo" size="md" />
					</Link>
				)}
				<div className={classes.headerInfo}>
					<HeaderInfo openSidebar={openSidebar} isOpen={isOpen} />
				</div>
			</SectionContainer>
		</div>
	)
}
